"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var AvatarSVG = react_1.memo(function (_a) {
    var authenticated = _a.authenticated;
    return (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 42 42", className: classnames_1.default(styles_module_scss_1.default.avatar_svg, authenticated
            ? styles_module_scss_1.default.authenticated
            : styles_module_scss_1.default.non_authenticated) },
        react_1.default.createElement("g", { id: "user-avatar-filled-alt", transform: "translate(-2.25 -2.25)" },
            react_1.default.createElement("path", { id: "Path_313", "data-name": "Path 313", d: "M23.25,2.25a21,21,0,1,0,21,21A21,21,0,0,0,23.25,2.25Zm12,34.379v-.912a7.813,7.813,0,0,0-7.5-7.967h-9a7.8,7.8,0,0,0-7.485,7.965c0,.016-.015.033-.015.049v.877a18.008,18.008,0,1,1,24-.015Z", transform: "translate(0 0)" }),
            react_1.default.createElement("path", { id: "Path_314", "data-name": "Path 314", d: "M20.171,7.875a7.8,7.8,0,1,0,7.8,7.8,7.8,7.8,0,0,0-7.8-7.8Z", transform: "translate(3.079 1.711)" }))));
});
exports.default = AvatarSVG;
